import { useState, useEffect } from "react";
import { PetugasMeterItem } from "../../../../model/Hublang";
import { fetchGetKoreksiMeterPetugas } from "../../../../controller/dashboard/Cekmeter";

export const PetugasMeter = () => {

    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10); // bisa default 

    const [statusLength, setStatusLength] = useState('10');
    const [petugasMeterData, setPetugasMeterData] = useState<PetugasMeterItem[]>([]);


    const filteredPhotoMeters = petugasMeterData.filter(plg => {
        const matchesSearch = true;

        const matchesStatus = true;

        return matchesSearch && matchesStatus;
    });

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentPhotoMeters = filteredPhotoMeters.slice(indexOfFirstItem, indexOfLastItem);
    let totalPages = itemsPerPage > 0 ? Math.ceil(filteredPhotoMeters.length / itemsPerPage) : 0;
    const pageNumbers = totalPages > 0 ? Array.from({ length: totalPages }, (_, i) => i + 1) : [];

    const initDataPhotoMeter = async () => { 
        setLoading(true); // Set loading state ke true sebelum memulai fetch
        try {
            const res = await fetchGetKoreksiMeterPetugas(); // Panggil API
            if (res.status === 200 && Array.isArray(res.data)) {

                const today = new Date();
                today.setHours(0, 0, 0, 0);

                const processedData = res.data.map((item: any) => ({
                    no: 0,
                    nama: item.nama || "Tidak ada data",
                    wilayah: item.wilayah || "Tidak ada data",
                }));

                const sortedData = processedData;
                setPetugasMeterData(sortedData);
            } else {
                console.error("Invalid response data:", res.data);
                setPetugasMeterData([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            setPetugasMeterData([]);
        } finally {
            setLoading(false);
        }
    };

    const RenderTablePetugasMeter = ({ filteredData }: { 
        filteredData: PetugasMeterItem[] | null; 
    }) => (
      <>
        {
          filteredData && filteredData.length > 0 ? (
            filteredData.map((plg, idx) => (
              <tr key={idx} className="bg-gray-50 hover:bg-gray-200 transition-colors">
                <td className="px-6 py-4 whitespace-nowrap">
                    {idx + 1}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {plg.nama}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                    {plg.wilayah}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={18} className="text-center py-4 text-gray-500">
                Tidak ada data
              </td>
            </tr>
          )
        }
      </>
    );
    
    useEffect(() => {
      initDataPhotoMeter();
      setItemsPerPage(Number(statusLength === 'all' ? petugasMeterData.length : statusLength))
    }, []);

    return (
      <>
        {/* Employee Table */}
        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          <div className="overflow-x-auto">
              <table className="table-auto min-w-full max-w-screen-lg divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    NO
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    NAMA
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    WILAYAH
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                  {
                    loading? 
                    <>
                      <tr>
                        <td colSpan={18} className="text-center py-4 text-gray-500">
                          Sedang Loading . . .
                        </td>
                      </tr>
                    </>
                    :
                    <>
                      <RenderTablePetugasMeter filteredData={currentPhotoMeters} />
                    </>
                  }
              </tbody>
            </table>
          </div>
        </div>
  
        {/* Pagination */}
        <div className="mt-6 flex items-center justify-between">
        <div className="text-sm text-gray-700">
          Menampilkan <span className="font-medium">{currentPage}</span> hingga{' '}
          <span className="font-medium">{statusLength === "all" ? petugasMeterData.length : statusLength}</span> dari{' '}
          <span className="font-medium">{petugasMeterData.length}</span> karyawan
          <span className="font-medium">( Dari Sortir {filteredPhotoMeters.length} )</span>
        </div>
        <div className="flex space-x-2">
          <button 
          disabled={currentPage === 1}
          onClick={() => setCurrentPage(1)}
          className="px-3 py-2 text-sm text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
          First
          </button>
          <button 
          disabled={currentPage === 1}
          onClick={() => setCurrentPage(prev => prev - 1)}
          className="px-3 py-2 text-sm text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
          Previous
          </button>
          
          {pageNumbers
          .slice(
            Math.max(0, currentPage - 3), 
            Math.min(currentPage + 2, totalPages)
          )
          .map((page) =>( 
            <button 
            key={page}
            onClick={() => setCurrentPage(page)}
            className={`px-3 py-1 rounded ${ currentPage === page ? "bg-blue-500 text-white" : "bg-gray-200" }`}>
            {page}
            </button>
          ))}
          
          <button 
              disabled={currentPage === Math.ceil(filteredPhotoMeters.length / itemsPerPage)}
              onClick={() => setCurrentPage(prev => prev + 1)}
              className="px-3 py-2 text-sm text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
              Next
          </button>
          <button 
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(totalPages)}
              className="px-3 py-2 text-sm text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
              Last
          </button>
        </div>
        </div>
      </>
    )
};